module.exports = __webpack_public_path__ + "media/images/font/Gustavo-MediumItalic-5927dc2504d26564d3fdc2780b08e2f3.woff";